import { render, staticRenderFns } from "./EstacCordobaFormType.vue?vue&type=template&id=9702ce86&"
import script from "./EstacCordobaFormType.vue?vue&type=script&lang=js&"
export * from "./EstacCordobaFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports